// src/AdminPanel/SetDiscount.js
import React, { useState } from "react";
import SetProductDiscount from "./SetProductDiscount";
import SetCategoryDiscount from "./SetCategoryDiscount";
import ManageSale from "./ManageSale";

const TABS = [
  {
    key: "product",
    label: "Product Discount",
    icon: "fa-solid fa-box",
    description: "Apply a discount to individual products.",
  },
  {
    key: "category",
    label: "Category Discount",
    icon: "fa-solid fa-tags",
    description: "Apply a discount to all products within a category.",
  },
  {
    key: "global",
    label: "Global Discount",
    icon: "fa-solid fa-globe",
    description: "Configure a site-wide sale applied to all products.",
  },
];

function SetDiscount() {
  const [activeTab, setActiveTab] = useState("product");

  const activeTabInfo = TABS.find((t) => t.key === activeTab);

  return (
    <div className="set-discount-page">
      {/* ── Page Header ── */}
      <div className="set-discount-header">
        <h1 className="set-discount-title">
          <i
            className="fa-solid fa-percent"
            style={{ marginRight: 10, color: "var(--red)" }}
          ></i>
          Set Discount
        </h1>
        <p className="admin-page-subtitle" style={{ marginBottom: 0 }}>
          {activeTabInfo?.description}
        </p>

        {/* ── Tab Toggle Bar ── */}
        <div className="discount-tab-bar">
          {TABS.map((tab) => (
            <button
              key={tab.key}
              className={`discount-tab-btn${activeTab === tab.key ? " active" : ""}`}
              onClick={() => setActiveTab(tab.key)}
            >
              <i className={tab.icon}></i>
              {tab.label}
            </button>
          ))}
        </div>
      </div>

      {/* ── Tab Content ── */}
      {/* The .discount-tab-content wrapper strips the outer padding
          that each component applies via .upload-page so there is
          no double-indentation inside the unified page. */}
      <div className="discount-tab-content">
        {activeTab === "product" && <SetProductDiscount />}
        {activeTab === "category" && <SetCategoryDiscount />}
        {activeTab === "global" && <ManageSale />}
      </div>
    </div>
  );
}

export default SetDiscount;
